var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", { staticClass: "mt-2 mb-1" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.mobileHome.title) + "\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("section", { attrs: { id: "carrousel" } }),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c(
          "div",
          { staticClass: "row swiper-1row d-md-none my-2 my-md-4 text-center" },
          [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                { staticClass: "ob1-carrousel zone-menu-swiper-container" },
                [
                  _c(
                    "div",
                    { staticClass: "swiper-wrapper" },
                    _vm._l(
                      _vm.mobileHome.zoneMenu.zoneMenuItem,
                      function (zoneMenuItem, zoneMenuItemIndex) {
                        return _c(
                          "div",
                          {
                            key: zoneMenuItemIndex,
                            staticClass:
                              "swiper-slide d-flex justify-content-center",
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "no-decoration",
                                attrs: {
                                  href: zoneMenuItem.link,
                                  "data-oevent-category":
                                    zoneMenuItem.tms.tagZone,
                                  "data-oevent-action":
                                    zoneMenuItem.tms.tagName,
                                  "data-oevent-label": zoneMenuItem.link,
                                },
                              },
                              [
                                _c("div", {
                                  class:
                                    "icon " +
                                    zoneMenuItem.icon +
                                    " font-size-48",
                                  attrs: { "aria-hidden": "true" },
                                }),
                                _vm._v(" "),
                                _c("ob1-liens", {
                                  staticClass: "text-dark",
                                  attrs: {
                                    text: zoneMenuItem.text,
                                    href: zoneMenuItem.link,
                                    "no-decoration": "",
                                    "is-mini": "",
                                    "with-arrow": "",
                                    "data-oevent-category":
                                      zoneMenuItem.tms.tagZone,
                                    "data-oevent-action":
                                      zoneMenuItem.tms.tagName,
                                    "data-oevent-label": zoneMenuItem.link,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        )
                      }
                    ),
                    0
                  ),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-none d-md-block px-lg-3 my-2 my-md-4" },
          _vm._l(_vm.numberOfRows(6), function (y) {
            return _c(
              "div",
              { key: y, staticClass: "row text-center" },
              _vm._l(6, function (x) {
                return _c(
                  "div",
                  {
                    key: x,
                    staticClass: "col-2 px-0 d-flex justify-content-center",
                  },
                  [
                    _vm.mobileHome.zoneMenu.zoneMenuItem[_vm.index(x, y, 6)]
                      ? _c(
                          "a",
                          {
                            staticClass: "no-decoration",
                            attrs: {
                              href: _vm.mobileHome.zoneMenu.zoneMenuItem[
                                _vm.index(x, y, 6)
                              ].link,
                              "data-oevent-category":
                                _vm.mobileHome.zoneMenu.zoneMenuItem[
                                  _vm.index(x, y, 6)
                                ].tms.tagZone,
                              "data-oevent-action":
                                _vm.mobileHome.zoneMenu.zoneMenuItem[
                                  _vm.index(x, y, 6)
                                ].tms.tagName,
                              "data-oevent-label":
                                _vm.mobileHome.zoneMenu.zoneMenuItem[
                                  _vm.index(x, y, 6)
                                ].link,
                            },
                          },
                          [
                            _c("div", {
                              class:
                                "icon " +
                                _vm.mobileHome.zoneMenu.zoneMenuItem[
                                  _vm.index(x, y, 6)
                                ].icon +
                                " font-size-48",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(" "),
                            _c("ob1-liens", {
                              staticClass: "text-dark mb-1",
                              attrs: {
                                text: _vm.mobileHome.zoneMenu.zoneMenuItem[
                                  _vm.index(x, y, 6)
                                ].text,
                                href: _vm.mobileHome.zoneMenu.zoneMenuItem[
                                  _vm.index(x, y, 6)
                                ].link,
                                "with-arrow": "",
                                "is-mini": "",
                                "data-oevent-category":
                                  _vm.mobileHome.zoneMenu.zoneMenuItem[
                                    _vm.index(x, y, 6)
                                  ].tms.tagZone,
                                "data-oevent-action":
                                  _vm.mobileHome.zoneMenu.zoneMenuItem[
                                    _vm.index(x, y, 6)
                                  ].tms.tagName,
                                "data-oevent-label":
                                  _vm.mobileHome.zoneMenu.zoneMenuItem[
                                    _vm.index(x, y, 6)
                                  ].link,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.mobileHome.zoneContracts.zoneContractsItem.length > 0
        ? [
            _c("zone-contracts-collapse", {
              attrs: {
                "contracts-with-collapse": _vm.contractsWithCollapse,
                "contracts-with-not-collapse": _vm.contractsWithNotCollapse,
                "show-more-contracts-button-label":
                  _vm.showMoreContractsButtonLabel,
                "show-less-contracts-button-label":
                  _vm.showLessContractsButtonLabel,
                title: _vm.mobileHome.zoneContractsSubtitle,
              },
            }),
            _vm._v(" "),
            _vm.mobileHome.zoneMarchandParcoursOpen
              ? _c("zone-marchand-parcours", {
                  attrs: {
                    "zone-marchand-parcours":
                      _vm.mobileHome.zoneMarchandParcoursOpen,
                    title: _vm.mobileHome.zoneMarchandParcoursSubtitle,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.mobileHome.zoneMarchandParcoursMobile
              ? _c("zone-marchand-parcours", {
                  attrs: {
                    "zone-marchand-parcours":
                      _vm.mobileHome.zoneMarchandParcoursMobile,
                    title: _vm.mobileHome.zoneMarchandParcoursSubtitle,
                  },
                })
              : _vm._e(),
          ]
        : _vm.mobileHome.zoneRecoInternet
        ? [
            _c("zone-reco-internet", {
              attrs: { "zone-reco-internet": _vm.mobileHome.zoneRecoInternet },
            }),
          ]
        : [
            _c("zone-mobiles", {
              attrs: {
                "zone-mobiles": _vm.mobileHome.zoneMobiles,
                title: _vm.mobileHome.mobilesSubtitle,
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "pt-2 pb-2 pb-md-4 bg-gray2" }, [
              _c(
                "div",
                { staticClass: "container-fluid" },
                [
                  _c("zones-forfaits", {
                    attrs: {
                      "zone-offers": _vm.mobileHome.zoneOffers,
                      title: _vm.mobileHome.offersSubtitle,
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
      _vm._v(" "),
      _vm.mobileHome.hasConvergentOrMobileContract
        ? [
            _vm.loading
              ? [_c("skeleton-reco-mobiles-card")]
              : [
                  _vm.displayRecoMobiles
                    ? [
                        _c("reco-mobiles", {
                          attrs: {
                            mobiles: _vm.reco.mobiles,
                            title: _vm.reco.title,
                            shop: "ORANGE",
                            "advantage-messages":
                              _vm.mobileHome.advantageMessages,
                            "link-label":
                              _vm.mobileHome.zoneMobiles.zoneMobilesItem[1]
                                .labelButton,
                            "link-url":
                              _vm.mobileHome.zoneMobiles.zoneMobilesItem[0]
                                .urlButton,
                            "data-pdb-zid":
                              "shop-digital_cremaillere_n1_client_zone-reco-tuile_",
                            "funding-details-dto": _vm.fundingDetailsDto,
                          },
                          on: {
                            fundingDetailsClick: _vm.handleFundingDetailsClick,
                          },
                        }),
                        _vm._v(" "),
                        _vm.selectedFundingDetailVersionPrice
                          ? _c("pxf-cb4x-modal", {
                              attrs: {
                                "modal-id": "funding-details-popin",
                                "display-cb4x":
                                  _vm.selectedFundingDetailVersionPrice
                                    .isCb4xAvailable,
                                "display-pxf":
                                  _vm.selectedFundingDetailVersionPrice
                                    .isPxfAvailable,
                              },
                              scopedSlots: _vm._u(
                                [
                                  _vm.selectedFundingDetailVersionPrice
                                    .isCb4xAvailable
                                    ? {
                                        key: "cb4x-content",
                                        fn: function () {
                                          return [
                                            _vm.fundingDetailsDto.cb4xPopin
                                              .withFees
                                              ? _c(
                                                  "paying-detail-cb4x-modal-content",
                                                  {
                                                    attrs: {
                                                      "modal-id":
                                                        "funding-details-popin",
                                                      "oney-merchant-guid":
                                                        _vm.fundingDetailsDto
                                                          .cb4xPopin
                                                          .oneyMerchantGuid,
                                                      "oney-widget-src":
                                                        _vm.fundingDetailsDto
                                                          .oneyWidgetSrc,
                                                      "counter-delay":
                                                        _vm.fundingDetailsDto
                                                          .counterDelay,
                                                      amount:
                                                        _vm
                                                          .selectedFundingDetailVersionPrice
                                                          .totalPriceWithPromo /
                                                        100,
                                                      "header-block":
                                                        _vm.fundingDetailsDto
                                                          .cb4xPopin
                                                          .headerBlock,
                                                      "how-to-benefit":
                                                        _vm.fundingDetailsDto
                                                          .cb4xPopin
                                                          .howToBenefit,
                                                      cgu: _vm.fundingDetailsDto
                                                        .cb4xPopin.cgu,
                                                      illustration:
                                                        _vm.fundingDetailsDto
                                                          .cb4xPopin.imageZen,
                                                    },
                                                  }
                                                )
                                              : _vm
                                                  .selectedFundingDetailVersionPrice
                                                  .spreadingPrice4xCbWithoutFees
                                              ? _c("cb4x-modal-content", {
                                                  attrs: {
                                                    "header-block":
                                                      _vm.fundingDetailsDto
                                                        .cb4xPopin.headerBlock,
                                                    "payment-block":
                                                      _vm.fundingDetailsDto
                                                        .cb4xPopin.paymentBlock,
                                                    "payment-simulation-block":
                                                      _vm.fundingDetailsDto
                                                        .cb4xPopin
                                                        .paymentSimulationBlock,
                                                    "how-to-benefit":
                                                      _vm.fundingDetailsDto
                                                        .cb4xPopin.howToBenefit,
                                                    faq: _vm.fundingDetailsDto
                                                      .cb4xPopin.faqBlock,
                                                    cgu: _vm.fundingDetailsDto
                                                      .cb4xPopin.cgu,
                                                    "monthly-price":
                                                      _vm
                                                        .selectedFundingDetailVersionPrice
                                                        .spreadingPrice4xCbWithoutFees
                                                        .monthlyPrice,
                                                    "first-monthly-price":
                                                      _vm
                                                        .selectedFundingDetailVersionPrice
                                                        .spreadingPrice4xCbWithoutFees
                                                        .firstMonthlyPrice,
                                                    "one-shot-price":
                                                      _vm
                                                        .selectedFundingDetailVersionPrice
                                                        .spreadingPrice4xCbWithoutFees
                                                        .oneShotPrice,
                                                    illustration:
                                                      _vm.fundingDetailsDto
                                                        .cb4xPopin.imageZen,
                                                  },
                                                })
                                              : _vm._e(),
                                          ]
                                        },
                                        proxy: true,
                                      }
                                    : null,
                                  _vm.selectedFundingDetailVersionPrice
                                    .isPxfAvailable
                                    ? {
                                        key: "pxf-content",
                                        fn: function () {
                                          return [
                                            _c("pxf-modal-content", {
                                              attrs: {
                                                "header-block-dto":
                                                  _vm.fundingDetailsDto.pxfPopin
                                                    .headerBlockDto,
                                                "example-pxf-data":
                                                  _vm.fundingDetailsDto.pxfPopin
                                                    .examplePxfData,
                                                "example-pxf-tab-subtitle":
                                                  _vm.fundingDetailsDto.pxfPopin
                                                    .examplePxfTabSubtitle,
                                                "example-pxf-tab-title":
                                                  _vm.fundingDetailsDto.pxfPopin
                                                    .examplePxfTabTitle,
                                                "version-pxf-data":
                                                  _vm
                                                    .selectedFundingDetailVersionPrice
                                                    .versionPxfData,
                                                "version-pxf-tab-title":
                                                  _vm.fundingDetailsDto.pxfPopin
                                                    .versionPxfTabTitle,
                                                "pxf-legal-mentions-text":
                                                  _vm.fundingDetailsDto.pxfPopin
                                                    .pxfLegalMentionsText,
                                                illustration:
                                                  _vm.fundingDetailsDto.pxfPopin
                                                    .imageZen,
                                                "financing-block":
                                                  _vm.fundingDetailsDto.pxfPopin
                                                    .financingBlock,
                                                cgu: _vm.fundingDetailsDto
                                                  .pxfPopin.cguDto,
                                                "how-to-benefit-dto":
                                                  _vm.fundingDetailsDto.pxfPopin
                                                    .howToBenefitDto,
                                              },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      }
                                    : null,
                                ],
                                null,
                                true
                              ),
                            })
                          : _vm._e(),
                      ]
                    : [
                        _c("zone-equipments", {
                          attrs: {
                            "equipments-band": _vm.mobileHome.equipmentsBand,
                            title: _vm.mobileHome.equipmentsBandSubtitle,
                            "label-button":
                              _vm.mobileHome.zoneMobiles.zoneMobilesItem[1]
                                .labelButton,
                            "url-button":
                              _vm.mobileHome.zoneMobiles.zoneMobilesItem[0]
                                .urlButton,
                          },
                        }),
                      ],
                ],
          ]
        : [
            _c("zone-equipments", {
              attrs: {
                "equipments-band": _vm.mobileHome.equipmentsBand,
                title: _vm.mobileHome.equipmentsBandSubtitle,
                "label-button":
                  _vm.mobileHome.zoneMobiles.zoneMobilesItem[1].labelButton,
                "url-button":
                  _vm.mobileHome.zoneMobiles.zoneMobilesItem[0].urlButton,
              },
            }),
          ],
      _vm._v(" "),
      _vm.mobileHome.zoneReassuranceEquipments
        ? _c(
            "div",
            { staticClass: "container-fluid" },
            [
              _c("zone-reassurance-equipments", {
                attrs: {
                  "zone-reassurance-equipments":
                    _vm.mobileHome.zoneReassuranceEquipments,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-fluid" },
        [
          _c("zone-reassurance", {
            attrs: { "zone-reassurance": _vm.mobileHome.zoneReassurance },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("legal-mentions-device", {
        attrs: {
          title: _vm.mobileHome.legalMentions.title,
          "pxf-legal-mentions-text": _vm.hasDeviceWithPxFPromoted
            ? _vm.mobileHome.legalMentions.pxfMention
            : null,
          "cb4x-legal-mentions-text": _vm.hasDeviceWith4xCBPromoted
            ? _vm.mobileHome.legalMentions.cb4xMention
            : null,
          "popin4x-cb": _vm.mobileHome.legalMentions.popin4xCb,
          "general-legal-mentions":
            _vm.mobileHome.legalMentions.generalMentions,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "bg-gray2 pt-1 pb-2" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c("h3", {
            staticClass: "lead fw-bold mb-0",
            domProps: {
              innerHTML: _vm._s(_vm.mobileHome.deviceMentions.title),
            },
          }),
          _vm._v(" "),
          _c("div", {
            staticClass: "small mb-2",
            domProps: { innerHTML: _vm._s(_vm.mobileHome.deviceMentions.text) },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bg-dark" }, [
        _c(
          "div",
          { staticClass: "container-fluid" },
          [
            _c("orange-commitments", {
              attrs: { commitments: _vm.mobileHome.orangeCommitments },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "bg-dark pt-1 pt-md-2 pb-1" }, [
        _c(
          "div",
          { staticClass: "container-fluid" },
          [
            _c("ob1-breadcrumb", {
              attrs: {
                "is-inverse": "",
                items: _vm.mobileHome.filAriane.items,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }